import { render } from "./TheError.vue?vue&type=template&id=386a6e86"
import script from "./TheError.vue?vue&type=script&lang=ts"
export * from "./TheError.vue?vue&type=script&lang=ts"

import "./TheError.vue?vue&type=style&index=0&id=386a6e86&lang=css"
script.render = render

export default script